import { reactive } from 'vue'

// Global, transient feedback. One shared store; <ToastHost> renders it once at
// the app root. Call from anywhere: const toast = useToast(); toast.error('…').
//
// Durations (ms). Errors don't auto-dismiss — they stay until the user closes
// them (or another action clears them), so a failure is never missed.
const DURATIONS = { success: 4000, info: 4500, warning: 6000, error: 0 }
const MAX_VISIBLE = 5

let seq = 0
const toasts = reactive([])

function clearTimer(t) {
  if (t._timer) { clearTimeout(t._timer); t._timer = null }
}

function dismiss(id) {
  const i = toasts.findIndex(t => t.id === id)
  if (i !== -1) {
    clearTimer(toasts[i])
    toasts.splice(i, 1)
  }
}

function startTimer(t) {
  clearTimer(t)
  if (t.duration > 0) {
    t._timer = setTimeout(() => dismiss(t.id), t.duration)
  }
}

function push(type, message, opts = {}) {
  // Collapse exact duplicates that are still showing (e.g. a repeated failure).
  const dup = toasts.find(t => t.type === type && t.message === message)
  if (dup) { startTimer(dup); return dup.id }

  const id = ++seq
  const t = reactive({
    id,
    type,
    message,
    title: opts.title || '',
    duration: opts.duration != null ? opts.duration : DURATIONS[type],
    _timer: null,
  })
  toasts.push(t)
  // Cap the stack — drop the oldest so they never blanket the screen.
  while (toasts.length > MAX_VISIBLE) dismiss(toasts[0].id)
  startTimer(t)
  return id
}

// Pause/resume the auto-dismiss countdown (used on hover/focus).
function pause(id) { const t = toasts.find(x => x.id === id); if (t) clearTimer(t) }
function resume(id) { const t = toasts.find(x => x.id === id); if (t) startTimer(t) }

export function useToast() {
  return {
    toasts,
    dismiss,
    pause,
    resume,
    success: (m, o) => push('success', m, o),
    error:   (m, o) => push('error',   m, o),
    warning: (m, o) => push('warning', m, o),
    info:    (m, o) => push('info',    m, o),
  }
}
